export default __webpack_public_path__ + "static/media/friedrice1.d2d0fa21.jpg";